/** Curated cover gradients — warm peach/cream/charcoal from DESIGN.md tokens only. */

const C = {
  canvas: "#FBF9F5",
  cream: "#fdfbf7",
  surface: "#ffffff",
  peach: "#f0e0d0",
  blush: "#e8c4d8",
  live: "#c4784a",
  ink: "#121212",
  orchid: "#dcc5f0",
};

export const COVER_GRADIENTS = {
  pink: {
    label: "Warm Blush",
    background: `linear-gradient(145deg, ${C.cream} 0%, ${C.peach} 42%, ${C.blush} 100%)`,
  },
  amber: {
    label: "Sand Warmth",
    background: `linear-gradient(155deg, ${C.cream} 0%, ${C.peach} 42%, ${C.live} 100%)`,
  },
  purple: {
    label: "Stone Mist",
    background: `linear-gradient(135deg, ${C.canvas} 0%, ${C.peach} 45%, ${C.blush} 100%)`,
  },
  sky: {
    label: "Peach Dawn",
    background: `linear-gradient(160deg, ${C.cream} 0%, ${C.peach} 48%, ${C.blush} 100%)`,
  },
  "ember-blush": {
    label: "Warm Clay",
    background: `linear-gradient(125deg, ${C.peach} 0%, ${C.live} 40%, ${C.blush} 100%)`,
  },
  "plum-glow": {
    label: "Dust Rose",
    background: `linear-gradient(140deg, ${C.cream} 0%, ${C.blush} 40%, ${C.peach} 100%)`,
  },
  "night-ember": {
    label: "Charcoal Ember",
    background: `linear-gradient(150deg, ${C.peach} 0%, ${C.live} 40%, ${C.ink} 100%)`,
  },
  "floor-lights": {
    label: "Floor Lights",
    background: `linear-gradient(135deg, ${C.blush} 0%, ${C.peach} 35%, ${C.cream} 70%, ${C.live} 100%)`,
  },
  "salsa-heat": {
    label: "Salsa Heat",
    background: `linear-gradient(120deg, ${C.cream} 0%, ${C.peach} 45%, ${C.live} 100%)`,
  },
  "bachata-moon": {
    label: "Bachata Moon",
    background: `linear-gradient(165deg, ${C.canvas} 0%, ${C.peach} 50%, ${C.blush} 100%)`,
  },
  "kizomba-dusk": {
    label: "Kizomba Dusk",
    background: `linear-gradient(145deg, ${C.peach} 0%, ${C.blush} 55%, ${C.ink} 100%)`,
  },
  "social-spark": {
    label: "Social Spark",
    background: `radial-gradient(ellipse 120% 80% at 20% 20%, ${C.cream} 0%, transparent 55%), linear-gradient(155deg, ${C.peach} 0%, ${C.live} 55%, ${C.ink} 100%)`,
  },
  "venue-gold": {
    label: "Venue Gold",
    background: `linear-gradient(140deg, ${C.cream} 0%, ${C.peach} 40%, ${C.live} 85%)`,
  },
  "lavender-haze": {
    label: "Warm Haze",
    background: `linear-gradient(160deg, ${C.canvas} 0%, ${C.orchid} 55%, ${C.blush} 100%)`,
  },
  "copper-sunset": {
    label: "Copper Sunset",
    background: `linear-gradient(130deg, ${C.cream} 0%, ${C.peach} 45%, ${C.live} 100%)`,
  },
  "midnight-orchid": {
    label: "Midnight Clay",
    background: `radial-gradient(ellipse 90% 70% at 85% 15%, ${C.peach} 0%, transparent 55%), linear-gradient(155deg, ${C.blush} 0%, ${C.live} 55%, ${C.ink} 100%)`,
  },
};

export const COVER_GRADIENT_IDS = Object.keys(COVER_GRADIENTS);

const DEFAULT_COVER_ID = "pink";

/** Resolve a stored cover_color key to gradient metadata (legacy keys included). */
export function getCoverGradient(coverColor) {
  const key = coverColor && COVER_GRADIENTS[coverColor] ? coverColor : DEFAULT_COVER_ID;
  return COVER_GRADIENTS[key];
}

/** Inline style for a cover block background. */
export function coverBackgroundStyle(coverColor) {
  return { background: getCoverGradient(coverColor).background };
}

/** Pick `count` distinct gradient ids, optionally pinning one selection. */
export function pickCoverGradientOptions({ count = 4, includeId } = {}) {
  const pool = [...COVER_GRADIENT_IDS];
  for (let i = pool.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  let picked = pool.slice(0, count);
  if (includeId && COVER_GRADIENTS[includeId] && !picked.includes(includeId)) {
    picked = [includeId, ...picked.filter((id) => id !== includeId).slice(0, count - 1)];
  }
  return picked;
}
